import { SHIELD_PATH } from '../graph/constants'
import { useTheme } from '@mui/material'

interface Props extends React.SVGProps<SVGSVGElement> {
  plus?: boolean
  outline?: boolean
  offline?: boolean
  currentColor?: boolean
  size?: number
}

export default function IconNetwork({ plus, outline, offline, currentColor, size = 38, ...props }: Props) {
  const { palette } = useTheme()

  return (
    <svg width={size} height={size} viewBox="-2.5 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d={SHIELD_PATH}
        fill={offline ? palette.contrast.low : currentColor ? 'currentColor' : palette.primary.main}
        stroke={palette.background.default}
        vectorEffect="non-scaling-stroke"
        strokeWidth={outline ? 2 : 0}
      ></path>
      {plus && (
        <g transform="translate(3.75, 2) scale(0.7)" stroke={palette.background.default} strokeWidth={2}>
          <path d="M5 12h14" vectorEffect="non-scaling-stroke"></path>
          <path d="M12 5v14" vectorEffect="non-scaling-stroke"></path>
        </g>
      )}
    </svg>
  )
}
